import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles<Theme>((theme) => ({
  inputText: () => ({
    width: '100%',
    borderRadius: '10px',
    overflow: 'hidden',

    '& .MuiFilledInput-root': {
      background: '#fff',
      borderRadius: 'inherit',
      overflow: 'hidden'
    },

    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none'
    },

    '& .MuiFilledInput-underline:after': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiFilledInput-underline.Mui-error:after': {
      borderColor: '#f44336'
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red'
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7'
    }
  }),
  inputTextSecondary: () => ({
    width: '100%',
    borderRadius: '4px',

    '& .MuiOutlinedInput-root': {
      background: '#fff',
      borderRadius: 'inherit'
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiOutlinedInput-notchedOutline.Mui-error': {
      borderColor: '#f44336'
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main
    },
    '& .MuiFormLabel-asterisk': {
      color: 'red'
    },
    '& .Mui-disabled': {
      backgroundColor: '#d7d7d7'
    },
    '& .MuiFormHelperText-root.Mui-disabled': {
      color: theme.palette.error.main,
      background: 'none'
    }
  })
}));